// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_f2-a";
export var fulfillmentFormRail = "_f2-9";
export var headerTitleRow = "_f2-c";
export var orderDetailsWrapper = "_f2-7";
export var orderLinkTrigger = "_f2-2";
export var paymentInformationGrid = "_f2-h";
export var paymentSummaryColumn = "_f2-i";
export var shipmentContainer = "_f2-b";
export var shipmentDetailsMainPane = "_f2-8";
export var shipmentNavigationCard = "_f2-5";
export var shipmentNavigationRail = "_f2-3";
export var shipmentNavigationRailHeader = "_f2-4";
export var shipmentSummaryFact = "_f2-e";
export var shipmentSummaryGrid = "_f2-d";
export var shipmentSummaryMetadataRow = "_f2-f";
export var shipmentSummaryTags = "_f2-g";
export var shipmentWorkspace = "_f2-0";
export var shipmentWorkspaceContent = "_f2-6";
export var shipmentWorkspaceHeader = "_f2-1";